import React from "react";
import { Dropdown } from "primereact/dropdown";
import type { SelectedPeriod } from "../../../types/kpiDashboard";

interface Props {
  periods: SelectedPeriod[];
  value: SelectedPeriod;
  onChange: (period: SelectedPeriod) => void;
}

const PeriodSelector: React.FC<Props> = ({ periods, value, onChange }) => {
  const years = [...new Set(periods.map((p) => p.year))].sort((a, b) => b - a);

  const weeksForYear = periods
    .filter((p) => p.year === value.year)
    .sort((a, b) => b.week - a.week);

  const handleYearChange = (year: number) => {
    const latest = periods
      .filter((p) => p.year === year)
      .sort((a, b) => b.week - a.week)[0];
    if (!latest) return;
    onChange(latest);
  };

  const yearOptions = years.map((y) => ({ label: String(y), value: y }));
  const weekOptions = weeksForYear.map((p) => ({
    label: `KW${String(p.week).padStart(2, "0")}`,
    value: p.week,
  }));

  return (
    <div className="flex gap-2 align-items-center">
      <span className="text-xs text-color-secondary">Period:</span>
      <Dropdown
        value={value.year}
        options={yearOptions}
        onChange={(e) => handleYearChange(e.value)}
        style={{ width: "8rem" }}
      />
      <Dropdown
        value={value.week}
        options={weekOptions}
        onChange={(e) => onChange({ year: value.year, week: e.value })}
        style={{ width: "9rem" }}
      />
    </div>
  );
};

export default PeriodSelector;
